import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getLogOpList, getLogNames } from '@blade-sxp/account/api/log';
let default_1 = class default_1 extends Vue {
    keyword;
    end_time;
    start_time;
    log_name = '';
    pagination = {
        page: 1,
        size: 10,
        total: 0,
    };
    multipleSelection = [];
    logOpList = [];
    loading = false;
    filterName = [];
    initI18n() {
        this.getLogNames();
        this.getLogOpList();
    }
    handleSelectionChange(selection) {
        this.multipleSelection = selection;
    }
    handleSizeChange(val) {
        this.pagination.size = val;
        this.getLogOpList();
    }
    handleCurrentChange(val) {
        this.pagination.page = val;
        this.getLogOpList();
    }
    handleClear() {
        this.$refs.multipleTable.clearSelection();
    }
    /**
     *@Description: 操作日志列表
     *@Date: 2020-09-07 15:54:36
     */
    getLogOpList(search = false) {
        let data = {
            end_time: this.end_time,
            keyword: this.keyword,
            order: 1,
            log_name: this.log_name,
            page: search ? 1 : this.pagination.page,
            pageSize: this.pagination.size,
            start_time: this.start_time,
        };
        this.loading = true;
        getLogOpList(data)
            .then((resp) => {
            if (resp.data.data.list.length > 0) {
                this.logOpList = resp.data.data.list;
            }
            else {
                this.logOpList = [];
                if (resp.data.data.totalPage > 1) {
                    this.pagination.page = resp.data.data.totalPage;
                    this.getLogOpList();
                }
            }
            this.pagination.total = resp?.data?.data?.total ?? 0;
        })
            .finally(() => {
            this.loading = false;
        });
    }
    getLogNames() {
        getLogNames()
            .then((resp) => {
            const list = resp?.data?.data || [];
            this.filterName = list.map((item) => ({ value: item.key, text: item.display_name }));
        })
            .catch((er) => { });
    }
    filterChange(value) {
        const { operate_name } = value;
        this.log_name = operate_name?.[0] || '';
        this.getLogOpList();
    }
    mounted() {
        this.getLogOpList();
        this.getLogNames();
    }
};
__decorate([
    Prop()
], default_1.prototype, "keyword", void 0);
__decorate([
    Prop()
], default_1.prototype, "end_time", void 0);
__decorate([
    Prop()
], default_1.prototype, "start_time", void 0);
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "initI18n", null);
default_1 = __decorate([
    Component({
        name: 'operationLog',
    })
], default_1);
export default default_1;
